import { createContext, useContext } from 'react'
import type { FacesheetTab } from '#src/components/patient/detail-content/facesheet/facesheetObservability.ts'

export interface FacesheetTabContextValue {
  participantId: string
  tab: FacesheetTab
}

// Published per tab by PatientDetailContent so cards can say where their RUM
// actions happened. Null outside the facesheet (stories, standalone pages).
export const FacesheetTabContext =
  createContext<FacesheetTabContextValue | null>(null)

export function useFacesheetTab(): FacesheetTabContextValue | null {
  return useContext(FacesheetTabContext)
}
